export const TOKEN = "token";
export const BROWSER_ID = "browser_id";
export const USER = "usuario";
export const LANG = "LANG";
export const DEFAULT_LANG = "en";

export const RADAR_ARTIST_RANKING_HIGHLIGHTED_ARTISTS =
  "RADAR_HIGHLIGHTED_ARTISTS";
export const RADAR_ARTIST_RANKING_INDEX = "RADAR_RANKING_INDEX";
export const RADAR_ARTIST_RANKING_FILTER = "RADAR_RANKING_FILTER";
export const RADAR_AUDIO_FEATURE_TREND_FILTER =
  "RADAR_AUDIO_FEATURE_TREND_FILTER";
export const RADAR_AUDIO_FEATURE_TREND_AUDIO_FEATURE =
  "RADAR_AUDIO_FEATURE_TREND_AUDIO_FEATURE";
export const RADAR_GENRE_AUDIO_FEATURE_TREND_AUDIO_FILTER =
  "RADAR_GENRE_AUDIO_FEATURE_TREND_AUDIO_FILTER";
export const RADAR_GENRE_AUDIO_FEATURE_TREND_AUDIO_FEATURE =
  "RADAR_GENRE_AUDIO_FEATURE_TREND_AUDIO_FEATURE";
export const RADAR_GENRE_AUDIO_FEATURE_TREND_AUDIO_GENRES =
  "RADAR_GENRE_AUDIO_FEATURE_TREND_AUDIO_GENRES";

export const RADAR_LABEL_RAKNING_INDEX = "RADAR_LABEL_RAKNING_INDEX";
export const RADAR_LABEL_RAKNING_FILTER = "RADAR_LABEL_RAKNING_FILTER";

export const RADAR_RELEASE_RANKING_INDEX = "RADAR_RELEASE_RANKING_INDEX";
export const RADAR_RELEASE_RANKING_FILTER = "RADAR_RELEASE_RANKING_FILTER";
export const RADAR_RELEASE_RANKING_HIGHLIGHTED_ARTISTS =
  "RADAR_RELEASE_HIGHLIGHTED_ARTISTS";

export const RADAR_TRACKS_RANKING_INDEX = "RADAR_TRACKS_RANKING_INDEX";
export const RADAR_TRACKS_RANKING_FILTER = "RADAR_TRACKS_RANKING_FILTER";
export const RADAR_TRACKS_RANKING_HIGHLIGHTED_ARTISTS =
  "RADAR_TRACKS_HIGHLIGHTED_ARTISTS";

export const RADAR_ROLE_RANKING_INDEX = "RADAR_ROLE_RANKING_INDEX";
export const RADAR_ROLE_RANKING_FILTER = "RADAR_ROLE_RANKING_FILTER";

export const RADAR_TOP_SPOTIFY_FILTER = "RADAR_TOP_SPOTIFY_FILTER";
export const RADAR_TOP_SPOTIFY_GENRES = "RADAR_TOP_SPOTIFY_GENRES";

export const RADAR_SELECTED_LABEL = "RADAR_SELECTED_LABEL";

export const RADAR_HOME_FILTER = "RADAR_HOME_FILTER";

export const REFERENCE_PAGE = "REFERENCE_PAGE";
